export class Guide {
  id: string;
  name: string;
  slug: string;
  cid: string;
  type: string;
  licenseNumber: string;
  headshot: any;
  languageString: string;
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/models/guide.ts